module.exports = __webpack_public_path__ + "static/img/多智能体协作@2x.50d22f67.png";